export const DEFAULT_TAX_RATE = 9.25;
